export default function downloadBlob(blob, name) {
    // Create blob link to download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    // Set attributes
    link.setAttribute('href', url);
    link.setAttribute('download', name);

    // Append to html page
    document.body.appendChild(link);
    // Force download
    link.click();
    // Clean up and remove the link
    link.parentNode.removeChild(link);
}
